import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { setTitle } from '../../../redux/title/action';
import { RenderForm } from '../../../components/forms';
import { useForm } from 'react-hook-form';
import { FOMR_INPUT_REGISTER, FORM_SUPER_MEMBER_STORE } from './forms';
import { StyledContainer } from '../register-line/styles';
import { ContainerButton } from '../../../styles/global-style';
import { ButtonTheme } from '../../../components/buttons';
import { Checkbox, Spin, Typography, Row, Alert, Card, Button } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { channelBuyQuery } from '../../../services/react-query/optionMasterQuery';
import { useProductOptions } from './func/useProductOptions';
import { useModal } from '../../../components/modal/hooks/useModal';
import { SuperMember } from './modals/SuperMember';
import { useInsertWarranty } from './hooks/useInsertWarranty';
import { handleSubmitForm } from './func/submitHandler';
import { ROUTES_PATH } from '../../../resources/routes-name';
import { useGetStore } from './hooks/useGetStore';
import { color } from '../../../resources/color';
import { CustomImage } from '../../../functions/CustomImage';

const termsStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: '16px',
  flexDirection: 'column',
  gap: '16px',
};

const cardContainerStyle = {
  display: 'flex',
  overflowX: 'auto',
  gap: '16px',
  padding: '8px 4px',
  width: '100%',
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
};

const selectedCardContainerStyle = {
  ...cardContainerStyle,
  justifyContent: 'center',
  overflowX: 'hidden',
};

const cardStyle = {
  width: '160px',
  flex: '0 0 auto',
  marginBottom: '16px',
  backgroundColor: color.bg_gray,
};

const selectedCardStyle = {
  ...cardStyle,
  border: `2px solid ${color.blue}`,
};

const navigationButtonStyle = {
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  zIndex: 1,
  opacity: 0.8,
};

const cardContainerWrapperStyle = {
  position: 'relative',
  width: '100%',
};

const defaultValueSuperMember = {
  isSuperMemberSuccess: false,
};

export const RegisterInfo = () => {
  const { control, setValue, watch, getValues, handleSubmit } = useForm();
  const { open: openSuper, onToggle: onToggleSuper } = useModal();
  const dispatch = useDispatch();
  const history = useHistory();
  const [channelBuyType, setChannelBuyType] = useState('');
  const [isAccepted, setIsAccepted] = useState(false);
  const [superMemberInfo, setSuperMemberInfo] = useState(defaultValueSuperMember);
  const [, setIsSubmitting] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showLeftButton, setShowLeftButton] = useState(false);
  const [showRightButton, setShowRightButton] = useState(true);
  const containerRef = useRef(null);
  const { warranty } = useSelector((state) => state.warranty) || {};
  const userProfile = useSelector((state) => state.info);
  const channelBuyId = watch('channelBuyId');
  const mobileBrandId = watch('mobileBrandId');
  const mobileModelId = watch('mobileModelId');
  const storeId = watch('storeId');

  const { data: channelBuyList, isLoading: channelBuyLoading } = channelBuyQuery();
  const { mutate: mutateUpload, isPending: loadingInsertWarranty } = useInsertWarranty();
  const { mutate: mutateGetStore, isPending: isGetStorePending } = useGetStore({ storeId });

  useEffect(() => {
    if (storeId) {
      mutateGetStore();
    }
  }, [storeId]);

  useEffect(() => {
    const selectedChannelBuy = channelBuyList?.find((el) => el.value === channelBuyId);
    if (selectedChannelBuy && selectedChannelBuy.channelBuyType === 'FOCUS') {
      setChannelBuyType('FOCUS');
    } else if (selectedChannelBuy && selectedChannelBuy.channelBuyType === 'STORE') {
      setChannelBuyType('STORE');
    } else {
      setChannelBuyType('');
    }
  }, [channelBuyId, channelBuyList]);

  const { productOptions, brandOptions, modelOptions } = useProductOptions(
    mobileBrandId,
    mobileModelId,
    setValue,
  );

  useEffect(() => {
    dispatch(setTitle('ลงทะเบียนรับประกันสินค้า'));
  }, [dispatch]);

  useEffect(() => {
    if (warranty) {
      setValue('warrantyNumberCode', warranty?.warrantyNumberCode);
    }

    if (brandOptions.length === 1) {
      setValue('mobileBrandId', brandOptions[0]?.value);
    }

    if (modelOptions.length === 1) {
      setValue('mobileModelId', modelOptions[0]?.value);
    }

    if (productOptions.length === 1) {
      const p = productOptions[0];
      setValue('mapProductId', p?.value);
      setSelectedProduct(p);
    }
  }, [warranty, setValue, userProfile, productOptions, brandOptions, modelOptions]);

  useEffect(() => {
    if (!selectedProduct) {
      return;
    }
    const stillValid = productOptions.some((p) => p.value === selectedProduct.value);
    if (!stillValid) {
      setSelectedProduct(null);
      setIsAccepted(false);
      setValue('mapProductId', null);
    }
  }, [productOptions, selectedProduct, setValue]);

  useEffect(() => {
    if (warranty) {
      setValue('warrantyNumberCode', warranty?.warrantyNumberCode);
    }
    if (userProfile) {
      setValue('fullName', userProfile?.fullName);
      setValue('telephone', userProfile?.telephone);
    }
  }, [warranty, userProfile]);

  useEffect(() => {
    if (mobileModelId && productOptions.length > 0 && containerRef.current) {
      handleScroll();
    } else {
      setShowLeftButton(false);
      setShowRightButton(false);
    }
  }, [mobileModelId, productOptions]);

  const handleChange = useCallback(
    (_, item) => {
      switch (item.name) {
        case 'channelBuyId':
          setValue('mobileBrandId', null);
          setValue('mobileModelId', null);
          setValue('mapProductId', null);
          setSelectedProduct(null);
          setIsAccepted(false);
          break;
        case 'mobileBrandId':
          setValue('mobileModelId', null);
          setValue('mapProductId', null);
          setSelectedProduct(null);
          setIsAccepted(false);
          break;
        case 'mobileModelId':
          setValue('mapProductId', null);
          setSelectedProduct(null);
          setIsAccepted(false);
          break;
        default:
          break;
      }
    },
    [setValue],
  );

  const handlePolicyClick = () => {
    const path = ROUTES_PATH.ROUTE_TERM_WARRANTY.PATH;
    history.push(path);
  };

  const handleCheckboxChange = (e) => {
    if (!selectedProduct) {
      return;
    }
    setIsAccepted(e.target.checked);
  };

  const handleScroll = () => {
    if (containerRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = containerRef.current;
      setShowLeftButton(scrollLeft > 0);
      setShowRightButton(scrollLeft < scrollWidth - clientWidth - 10);
    }
  };

  const scroll = (direction) => {
    if (containerRef.current) {
      const scrollAmount = 300;
      containerRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  const handleSelectProduct = (product) => {
    setSelectedProduct(product);
    setValue('mapProductId', product.value);
  };

  const handleCancelProduct = () => {
    setSelectedProduct(null);
    setIsAccepted(false);
    setValue('mapProductId', null);
  };

  const onSubmit = (values) => {
    const payload = {
      ...values,
      mapProductId: selectedProduct?.value,
    };
    handleSubmitForm(payload, setIsSubmitting, mutateUpload);
  };

  const onSuperMemberSuccess = (values) => {
    setSuperMemberInfo(values);
  };

  return (
    <Spin spinning={channelBuyLoading || isGetStorePending}>
      <StyledContainer style={{ paddingBottom: '10px', maxWidth: '100vw' }}>
        <RenderForm
          control={control}
          setValue={setValue}
          getValues={getValues}
          forms={FOMR_INPUT_REGISTER({
            channelBuyType,
            channelBuyList,
            brandOptions,
            modelOptions,
            selectedProduct,
          })}
          onChange={handleChange}
        />
         <div style={termsStyle}>
          <Row justify="end">
            <Typography.Text>รุ่นฟิล์มและกระจกกันรอย</Typography.Text>
          </Row>
          <div style={cardContainerWrapperStyle}>
            {mobileModelId && showLeftButton && (
              <Button
                icon={<LeftOutlined />}
                onClick={() => scroll('left')}
                style={{ ...navigationButtonStyle, left: 0 }}
              />
            )}
            {mobileModelId && showRightButton && !selectedProduct && (
              <Button
                icon={<RightOutlined />}
                onClick={() => scroll('right')}
                style={{ ...navigationButtonStyle, right: 0 }}
              />
            )}
            <div
              ref={containerRef}
              style={selectedProduct ? selectedCardContainerStyle : cardContainerStyle}
              onScroll={handleScroll}
            >
              {(selectedProduct ? [selectedProduct] : productOptions).map((product, index) => (
                <Card
                  key={selectedProduct ? product.value : index}
                  style={product.value === selectedProduct?.value ? selectedCardStyle : cardStyle}
                >
                  <CustomImage
                    key={`img-${product.value}`}
                    src={product.productImageUrl}
                    alt={product.productFullName || product.label}
                    style={{ width: '100%', height: 'auto' }}
                    preview
                  />
                  <Typography.Text style={{ fontSize: '10px' }}>
                    ชื่อสินค้า: {product.productFullName || product.label}
                  </Typography.Text>
                  {!selectedProduct && (
                    <ButtonTheme
                      useFor="SELECT_PRODUCT"
                      onClick={() => handleSelectProduct(product)}
                      style={{ width: '100%', marginTop: '8px' }}
                    />
                  )}
                  {selectedProduct?.value === product.value && (
                    <ButtonTheme
                      useFor="CANCEL_SELECT_PRODUCT"
                      onClick={handleCancelProduct}
                      style={{ width: '100%', marginTop: '8px' }}
                    />
                  )}
                </Card>
              ))}
            </div>
          </div>
          <RenderForm
          control={control}
          setValue={setValue}
          getValues={getValues}
          forms={FORM_SUPER_MEMBER_STORE()}
        />
          <Checkbox
            checked={isAccepted}
            onChange={handleCheckboxChange}
            disabled={!selectedProduct}
          >
            <span style={{ color: !selectedProduct ? '#999' : 'inherit' }}>
              ฉันได้ยอมรับ
              {!selectedProduct && (
                <Typography.Text type="danger" style={{ marginLeft: '8px' }}>
                  (กรุณาเลือกสินค้าก่อน)
                </Typography.Text>
              )}
            </span>
          </Checkbox>
          <Row justify="end">
            <Typography.Link onClick={() => handlePolicyClick()} underline>
              ข้อตกลงการรับประกันสินค้า
            </Typography.Link>
          </Row>
          <ContainerButton center style={{ marginBottom: '13px' }}>
            {loadingInsertWarranty ? (
              <Spin spinning={loadingInsertWarranty} />
            ) : (
              <ButtonTheme
                useFor="REGISTER_WARRANTY"
                disabled={!isAccepted || !selectedProduct}
                onClick={handleSubmit(onSubmit)}
                style={{ marginBottom: '60px' }}
              />
            )}
          </ContainerButton>
        </div>
        <ContainerButton center>
          {superMemberInfo.isSuperMemberSuccess ? (
            <Alert
              message="ลงทะเบียน Super Member สำเร็จ"
              type="success"
              showIcon
              style={{ marginBottom: '10px' }}
            />
          ) : (
            <ButtonTheme useFor="SUPERMEMBER" onClick={onToggleSuper} />
          )}
          {openSuper && (
            <SuperMember
              open={openSuper}
              onToggle={onToggleSuper}
              onSuperMemberSuccess={onSuperMemberSuccess}
            />
          )}
        </ContainerButton>
      </StyledContainer>
    </Spin>
  );
};
